<template>
    <div class="c-product-color-selector">
        <BaseRadioButtonGroup
            :id="PRODUCT_COLOR_SELECTOR"
            :name="PRODUCT_COLOR_SELECTOR"
            :styleType="BUTTON_STYLE_TYPES.INLINE_TILE"
            :radioButtonItems="formattedOptions"
            :checkedItem="selectedChoice?.color?.code"
            @update:model-value="updateSelectedColor"
        >
            <template #default="{ id: slotId, isSelected, value: radioboxValue }">
                <ColorCardButton
                    :id="slotId"
                    :isSelected="isSelected"
                    :isAvailable="getOptionByValue(radioboxValue)?.available"
                    :color="getOptionByValue(radioboxValue)?.color"
                    class="c-product-color-selector__button u-text--gray"
                />
            </template>
        </BaseRadioButtonGroup>
    </div>
</template>

<script setup>
// NU_FEATURE: USE_BOX_COLOR_SELECTOR
// https://urbnit.atlassian.net/browse/TYP-27174
// delete this component
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useState, useMutations } from '~coreModules/core/js/composables/vuexHelpers';
import { SET_COLOR_CODE } from '~routes/product/js/product-store';
import { getProductModuleNameFromRoute } from '~coreRoutes/product/js/product-utils';
import { BUTTON_STYLE_TYPES } from '~coreModules/core/js/constants';

import { PRODUCT_COLOR_SELECTOR } from '~routes/product/js/product-constants';

import ColorCardButton from '~modules/core/components/ui/buttons/ColorCardButton.vue';
import BaseRadioButtonGroup from '~coreModules/core/components/ui/form-elements/radios/BaseRadioButtonGroup.vue';

const props = defineProps({
    choices: {
        type: Array,
        required: true,
    },
    selectedChoice: {
        type: Object,
        required: true,
    },
    sizeCodeAvailibilityByChoiceId: {
        type: Object,
        required: true,
    },
});

const route = useRoute();
const router = useRouter();

const productModuleName = computed(() => getProductModuleNameFromRoute(route));
const {
    selectedSkuSizeCode,
} = useState(productModuleName.value, {
    selectedSkuSizeCode: state => state.selectedSkuSizeCode,
});

const { setColorCode } = useMutations(productModuleName.value, {
    setColorCode: SET_COLOR_CODE,
});

const formattedOptions = computed(() => (props.choices || []).map(value => ({
    ...value,
    label: value.color?.displayName,
    value: value.color?.code,
})));

/* eslint-disable no-use-before-define */
const shapedOptions = computed(() => (formattedOptions.value
    .map(option => ({
        ...option,
        available: choiceHasAvailibilityForSizeCode(option.choiceId),
    }))
    .reduce((acc, option) => Object.assign(acc, {
        [option.color.code]: option,
    }), {})
));

function getOptionByValue(value) {
    return shapedOptions.value[value] || {};
}

function choiceHasAvailibilityForSizeCode(choiceId) {
    return !selectedSkuSizeCode.value ||
        props.sizeCodeAvailibilityByChoiceId[choiceId]?.includes(selectedSkuSizeCode.value?.code);
}

function updateSelectedColor(color) {
    router.replace({
        query: {
            color,
            ...(route.query?.view && {
                view: route.query?.view,
            }),
        },
    });
    setColorCode(color);
}

</script>

<style lang="scss">
.c-product-color-selector {
    $this: &;

    input {
        &[data-focus-visible-added]:not(:available) ~ #{$this}__button {
            outline: $focus-outline;
        }
    }
}
</style>
